import { ISearchFilter, ISearchFilterOption, ISearchFilterRangeOption } from '../types'

const getCurrentSelectedFilters = (filters: ISearchFilter[]) : (ISearchFilterOption | ISearchFilterRangeOption)[] => filters.flatMap(filter => [...filter.options]).filter(option => option.selected) as (ISearchFilterOption | ISearchFilterRangeOption)[]

export default getCurrentSelectedFilters